export const COLLAPSED = 'MapDisplayModes.COLLAPSED'
export const DEFAULT = 'MapDisplayModes.DEFAULT'
export const EXPANDED = 'MapDisplayModes.EXPANDED'
export const FULLSCREEN = 'MapDisplayModes.FULLSCREEN'

export default {
    COLLAPSED,
    DEFAULT,
    EXPANDED,
    FULLSCREEN,
}
